<template>
  <div>
    <div class="w-full bg-white">
      <v-dialog
        v-model="openAssignDialog"
        persistent
        max-width="350px"
        transition="dialog-transition"
      >
        <div class="bg-white px-4 py-2 w-full">
          <div class="justify-end flex">
            <v-btn text @click="close">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </div>
          <div
            class="
              text-center
              font-bold
              text-xl
              border-b-2 border-gray-800
              pb-2
            "
          >
            Assign to the following:
          </div>
          <div>
            <v-checkbox
              v-model="selected"
              label="Vertical"
              value="9"
            ></v-checkbox>
            <v-checkbox v-model="selected" label="North" value="7"></v-checkbox>
            <v-checkbox v-model="selected" label="South" value="8"></v-checkbox>
          </div>
          <v-btn color="primary" @click="assignSubmitted"> Enter </v-btn>
        </div>
      </v-dialog>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selected: [],
    };
  },
  props: ["openAssignDialog"],
  methods: {
    assignSubmitted() {
      if (this.selected.length > 0) {
        this.$emit("assignSubmitted", this.selected);
      } else {
        alert("Please choose a department to assign to");
      }
    },

    close() {
      this.$emit("closeAssignDialog");
    },
  },
};
</script>